import React, { useState, useContext, Fragment, useRef, useEffect } from 'react';
import Slider from 'react-input-slider'
import { db } from '../firebase'
import { Listbox, Transition, Dialog } from '@headlessui/react'
import { CheckIcon, ChevronUpDownIcon } from '@heroicons/react/20/solid'
import BarLoader from "react-spinners/BarLoader";
import { ChromePicker, CompactPicker } from 'react-color'
import { getFunctions, httpsCallable } from "firebase/functions";
import { SessionContext, SceneContext, StoryContext } from '/AppStoryPlayer'
import { Link } from 'react-router-dom';
import ExpHTML from '../experience/ExpHTML';
import GridSelect from './CompGridSelect'
import {
    query,
    collection,
    onSnapshot,
    updateDoc,
    doc,
    addDoc,
    deleteDoc,
} from 'firebase/firestore'
//import { iconSearch } from '../../b3-functions';
//import { set } from 'animejs';

/*
    --- INCOMING DATA FROM PARENT ---
    storyId={storyId}
    sceneData={sceneData}
    sessionData={sessionData}
    cardItem={item}
*/

const ConfigSuperCard = (props) => {

    // Various media animation styles
    const animationStyles = [
        { id: 1, name: 'none', displayName: 'None' },
        { id: 2, name: 'bounceIn', displayName: 'Bounce In' },
        { id: 3, name: 'fadeIn', displayName: 'Fade In' },
        { id: 4, name: 'fadeInDown', displayName: 'Fade In Down' },
        { id: 5, name: 'fadeInLeft', displayName: 'Fade In Left' },
        { id: 6, name: 'fadeInRight', displayName: 'Fade In Right' },
        { id: 7, name: 'fadeInUp', displayName: 'Fade In Up' },
        { id: 8, name: 'zoomIn', displayName: 'Zoom In' },
    ]

    const layoutStyles = [
        {
            id: 1,
            name: 'Default',
            previewSize: 2,
            category: 'Standard',
        },
        {
            id: 2,
            name: 'Icon Only',
            previewSize: 1,
            category: 'Icon',
        },
        {
            id: 7,
            name: 'Icon with Circle Background',
            previewSize: 1,
            category: 'Icon',
        },
        {
            id: 8,
            name: 'Icon with Square Background',
            previewSize: 1,
            category: 'Icon',
        },
        {
            id: 3,
            name: 'Body Only',
            previewSize: 2,
            category: 'Text',
        },
        {
            id: 4,
            name: 'Icon on Left',
            previewSize: 2,
            category: 'Standard',
        },
        {
            id: 5,
            name: 'Title Highlight with Icon',
            previewSize: 2,
            category: 'Standard',
        },
        {
            id: 6,
            name: 'Title, Icon and Subtitle',
            previewSize: 2,
            category: 'Standard',
        },
        {
            id: 9,
            name: 'Quote Style #1',
            previewSize: 3,
            category: 'Quote',
        },
        {
            id: 10,
            name: 'Quote Style #2',
            description: 'Quote using quation marks and via highlight color',
            previewSize: 3,
            category: 'Quote',
        },
        {
            id: 11,
            name: 'Quote Style #3',
            previewSize: 3,
            category: 'Quote',
        },
        {
            id: 12,
            name: 'Quote Style #4',
            previewSize: 3,
            category: 'Quote',
        },
        {
            id: 13,
            name: 'Icon on Top',
            previewSize: 2,
            category: 'Standard',
        },
        {
            id: 14,
            name: 'Icon on Top in Circle',
            previewSize: 2,
            category: 'Standard',
        },
        {
            id: 15,
            name: 'Title with Body',
            previewSize: 2,
            category: 'Text',
        },
        {
            id: 16,
            name: 'Icon on Left #2',
            previewSize: 2,
            category: 'Standard',
        },
        {
            id: 17,
            name: 'Chat Bubble - Arrow Left Side',
            previewSize: 2,
            category: 'Quote',
        },
        {
            id: 18,
            name: 'Chat Bubble - Arrow Right Side',
            previewSize: 2,
            category: 'Quote',
        },
        {
            id: 19,
            name: 'Click to Reveal',
            previewSize: 2,
            category: 'Interactive',
        },
        {
            id: 21,
            name: 'Icon above Card #2',
            description: 'Icon above card in circle using highlight color background',
            previewSize: 2,
            category: 'Standard',
        },
        // {
        //     id: 22,
        //     name: 'Navigate to New Scene',
        //     description: 'Navigate to another scene within your story, helps to open multiple paths and provide choice',
        //     previewSize: 2,
        //     category: 'Interactive',
        // },
        {
            id: 23,
            name: 'Navigate to New Scene',
            description: 'Navigate to another scene within your story, helps to open multiple paths and provide choice',
            previewSize: 2,
            category: 'Interactive',
        },
        {
            id: 24,
            name: 'Button to Navigate to New Scene',
            description: 'Single button to navigate to scene',
            previewSize: 2,
            category: 'Interactive',
        },        
    ]

    const themeColors = [
        'super-main-title-color',
        'super-subtitle-color',
        'super-body-color',
        'super-main-bg-color',
        'super-secondary-bg-color',
        'super-highlight-color',
        'super-list-icon-color',
        'nav-region-bg',
        'nav-button-text-off',
        'nav-button-text-on',
        'nav-button-bg-off',
        'nav-button-bg-on',
        'nav-progress-meter',
        'nav-progress-meter-bg',
    ]

    const [sceneData, setSceneData] = useContext(SceneContext)
    const [storyData, setStoryData] = useContext(StoryContext)

    let newPosCommit = 0



    const scrollToElement = (id) => {
        const container = document.getElementById(id);
        container.scrollIntoView({ behavior: 'smooth' });
    };



    const [iconList, setIconList] = useState([])

    let [color, setColor] = useState("#0ca5e9")
    const override = {
        width: "50%",
        margin: "auto",
        marginTop: "20%",
    }

    const [open, setOpen] = useState(false)
    const [scImage, setScImage] = useState('')

    const OpenIconSelectModal = ({ updateImage }) => {
        const [searchTerm, setSearchTerm] = useState('')
        const cancelButtonRef = useRef(null)
        const [iconLoading, setIconLoading] = useState(false)
        const [iconSelected, setIconSelected] = useState('')
        const [colorVariable, setColorVariable] = useState('ffffff')
        const [iconSelectedId, setIconSelectedId] = useState('')
        const [iconPreviewLoading, setIconPreviewLoading] = useState(false)

        const SearchIcons = () => {
            setIconLoading(true)
            const apiUrl = `https://us-central1-brevit3-57b00.cloudfunctions.net/getIconSearch?searchTerm=${encodeURIComponent(searchTerm)}`;
            //console.log('Calling API: ' + apiUrl)

            fetch(apiUrl)
                .then((response) => response.json())
                .then((data) => {
                    setIconList(data)
                    setIconLoading(false)
                    //      console.log('This is your data', data)
                }
                );
        }

        const GetIcon = (iconId, color = "ffffff") => {

            setIconPreviewLoading(true)
            const apiUrl = `https://us-central1-brevit3-57b00.cloudfunctions.net/getIconDownload?id=${encodeURIComponent(iconId)}&color=${encodeURIComponent(color)}`;
            //console.log('Calling API: ' + apiUrl)

            fetch(apiUrl)
                .then((response) => response.json())
                .then((data) => {
                    setIconPreviewLoading(false)
                    //      console.log('ICON....', data)
                    setIconSelected(data.result)
                }
                );
        }

        const handleChange = (newIcon) => {
            // console.log('GOT NEW ICON....')
            // console.log(newIcon)
            updateImage(newIcon)
            setScImage(newIcon)
        }

        return (
            <>
                <button type="button" className="text-gray-200  rounded text-sm px-5 w-full text-center py-2   items-center bg-white/5 hover:bg-white/10 " onClick={() => { setOpen(true) }}>
                    Select Icon
                </button>
                <Transition.Root show={open} as={Fragment}>
                    <Dialog as="div" className="relative z-10"
                        //initialFocus={cancelButtonRef} 
                        onClose={setOpen}>
                        <Transition.Child
                            as={Fragment}
                            enter="ease-out duration-300"
                            enterFrom="opacity-0"
                            enterTo="opacity-100"
                            leave="ease-in duration-200"
                            leaveFrom="opacity-100"
                            leaveTo="opacity-0"
                        >
                            <div className="fixed inset-0 bg-zinc-700 bg-opacity-50  transition-opacity" />
                        </Transition.Child>
                        <div className="fixed inset-0 z-10 overflow-y-auto">
                            <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                                <Transition.Child
                                    as={Fragment}
                                    enter="ease-out duration-300"
                                    enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                                    enterTo="opacity-100 translate-y-0 sm:scale-100"
                                    leave="ease-in duration-200"
                                    leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                                    leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95" >
                                    <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-zinc-900 px-4   text-left shadow-xl transition-all sm:my-8 w-6/12 sm:p-10" >
                                        <div>
                                            <div className='text-2xl text-gray-100'>Search for Icon
                                                {/* - TODO Presets by layout type... */}
                                            </div>
                                            <div className='text-base text-gray-300 mt-8'>Step 1 - Select Icon</div>
                                            <div className='grid grid-cols-8 gap-3 mt-4 mb-8'>
                                                <div className='col-span-7'>
                                                    <input
                                                        value={searchTerm}
                                                        onChange={(e) => setSearchTerm(e.target.value)}
                                                        onKeyUp={(e) => {
                                                            if (e.key === "Enter") {
                                                                SearchIcons()
                                                            }
                                                        }}
                                                        type="text"
                                                        placeholder='Search Term'
                                                        className="block w-full rounded-md border-0 px-4 py-2 bg-transparent text-gray-100 shadow-sm ring-1 ring-inset text-sm
                                                        ring-zinc-700 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-sky-400 sm:text-base sm:leading-6 focus:outline-none"
                                                    />
                                                </div>
                                                <div className='col-span-1'>
                                                    <div onClick={() => {
                                                        SearchIcons()
                                                    }
                                                    }
                                                        className='w-full justify-center rounded-md bg-sky-500 px-3 py-2
                      text-l font-base text-white shadow-sm bg-sky-600 hover:bg-sky-500 focus-visible:outline
                      focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 text-center'
                                                    >Search</div>
                                                </div>
                                            </div>
                                            <div className='grid grid-cols-10 gap-3 mt-2 mb-8'>
                                                {iconLoading ?
                                                    <div className='col-span-10 mb-12'>
                                                        <BarLoader
                                                            color={color}
                                                            loading={iconLoading}
                                                            cssOverride={override}
                                                            size={450}
                                                            aria-label="Loading Spinner"
                                                            data-testid="loader"
                                                        />
                                                    </div>
                                                    : null}
                                                {iconList ?
                                                    <>
                                                        {iconList.map((item) => (
                                                            <div className='bg-gray-200 hover:bg-white rounded' key={item.id}>
                                                                <img src={item.thumbnail_url} className='w-32 p-3' onClick={() => {
                                                                    setIconSelectedId(item.id)
                                                                    GetIcon(item.id, colorVariable.replace('#', ''))
                                                                }} />
                                                            </div>
                                                        ))}
                                                    </>
                                                    : (null)}
                                            </div>
                                            <div className='text-base text-gray-300 mt-8'>Step 2 - Select Color</div>
                                            <div className='w-full grid-cols-6 grid gap-3 b3-modal-ui'>
                                                {!iconSelectedId ?
                                                    <div className='text-zinc-400 col-span-6 mt-4'>
                                                        Please select an icon from your search above
                                                    </div>
                                                    : null}
                                                <div className='col-span-3 text-center'>
                                                    <BarLoader
                                                        color={color}
                                                        loading={iconPreviewLoading}
                                                        cssOverride={override}
                                                        size={450}
                                                        aria-label="Loading Spinner"
                                                        data-testid="loader"
                                                    />
                                                    {!iconPreviewLoading ?
                                                        <img src={iconSelected} className='w-1/2 p-3 mx-auto' />
                                                        : null}
                                                </div>
                                                <div className='col-span-3'>
                                                    <div className='ml-10 text-center'>
                                                        {iconSelectedId ?
                                                            <>
                                                                <div className='text-left text-zinc-400   p-2 '>Theme Colors</div>
                                                                <div className='grid grid-cols-12 gap-1 mt-2 pr-4 pl-1'>
                                                                    {themeColors.map((item, index) => (
                                                                        <div className=' h-6 rounded-sm cursor-pointer'
                                                                            key={item + 'colorkey'}
                                                                            style={{ background: storyData.uiStyle[item] }}
                                                                            onClick={() => {
                                                                                setColorVariable(storyData.uiStyle[item])
                                                                                GetIcon(iconSelectedId, storyData.uiStyle[item].replace('#', ''))
                                                                            }}
                                                                        >
                                                                        </div>
                                                                    ))}
                                                                </div>
                                                                <div className='text-left text-zinc-400 mt-8 mt-4 p-2 '>Custom Colors</div>
                                                                <CompactPicker
                                                                    style={{ width: '20px', background: '#000000' }}
                                                                    className="color-picker-dark icon-select"
                                                                    color={colorVariable}
                                                                    disableAlpha={false}
                                                                    onChange={(color) =>
                                                                        setColorVariable(color.hex)
                                                                    }
                                                                    onChangeComplete={(color, event) => {
                                                                        setColorVariable(color.hex)
                                                                        GetIcon(iconSelectedId, color.hex.replace('#', ''))
                                                                    }
                                                                    } />

                                                            </>
                                                            : null}
                                                    </div>
                                                </div>
                                                {/* <div className='col-span-1'>
                                                     'nav-button-bg-off': '#b3b3b3',
                                                        'nav-button-bg-on': '#222222',
                                                        'nav-button-text-off': '#4d4d4d',
                                                        'nav-button-text-on': '#009ce0',
                                                        'nav-progress-meter': '#808080',
                                                        'nav-progress-meter-bg': '#009ce0',
                                                        'nav-region-bg': '#222222',
                                                        'super-highlight-color': '#009ce0',
                                                        'super-list-icon-color': '#000000',
                                                        'super-list-text-color': '#000000',
                                                        'super-main-bg-color': '#111111',
                                                        'super-main-title-color': '#009ce0',
                                                        'super-secondary-bg-color': '#000000',
                                                        'super-subtitle-color': '#cccccc',
                                                    <div className='w-8 h-8 rounded ' onClick={setColorVariable()}>
                                                    </div>
                                                </div> */}
                                            </div>
                                        </div>
                                        <div className="mt-5 sm:mt-6 sm:grid sm:grid-flow-row-dense sm:grid-cols-2 sm:gap-3">
                                            <button
                                                type="button"
                                                className="inline-flex w-full justify-center rounded-md bg-sky-600 px-3 py-2   text-white shadow-sm hover:bg-sky-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 sm:col-start-2
                                                "
                                                onClick={() => {
                                                    handleChange(iconSelected)
                                                    setOpen(false)
                                                }
                                                }>
                                                Save
                                            </button>
                                            <button
                                                type="button"
                                                className="mt-3 inline-flex w-full justify-center 
                                                rounded bg-gray-500 px-3 py-2 bg-zinc-800
                                                text-base font-base text-gray-100 shadow-sm 
                                                hover:bg-zinc-700 sm:col-start-1 sm:mt-0"
                                                onClick={() => setOpen(false)}
                                                ref={cancelButtonRef} >
                                                Cancel
                                            </button>
                                        </div>
                                    </Dialog.Panel>
                                </Transition.Child>
                            </div>
                        </div>
                    </Dialog>
                </Transition.Root>
            </>
        )
    }




    // For layouts for SC
    const [openLayout, setOpenLayout] = useState(false)
    const [scLayout, setScLayout] = useState('')

    const OpenLayoutSelectModal = ({ updateImage }) => {
        const cancelButtonRef = useRef(null)
        // const [iconLoading, setIconLoading] = useState(false)
        // const [iconSelected, setIconSelected] = useState('')
        //const [colorVariable, setColorVariable] = useState('ffffff')
        const [layoutSelectedId, setLayoutSelectedId] = useState('')
        //const [iconPreviewLoading, setIconPreviewLoading] = useState(false)


        const handleChange = (newIcon) => {
            // updateImage(newIcon)
            // setScImage(newIcon)
        }



        return (
            <>
                <button type="button" className="text-gray-200  rounded text-sm px-5 w-full text-center py-2   items-center bg-white/5 hover:bg-white/10" onClick={() => { setOpenLayout(true) }}>
                    {/* <img src="/util/app/b3-genai.svg" className='h-7 w-7'/> */}
                    Select Layout
                </button>
                <Transition.Root show={openLayout} as={Fragment}>
                    <Dialog as="div" className="relative z-10"
                        //initialFocus={cancelButtonRef} 
                        onClose={setOpenLayout}>
                        <Transition.Child
                            as={Fragment}
                            enter="ease-out duration-300"
                            enterFrom="opacity-0"
                            enterTo="opacity-100"
                            leave="ease-in duration-200"
                            leaveFrom="opacity-100"
                            leaveTo="opacity-0"
                        >
                            <div className="fixed inset-0 bg-zinc-700 bg-opacity-50  transition-opacity" />
                        </Transition.Child>
                        <div className="fixed inset-0 z-10 overflow-y-auto">
                            <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                                <Transition.Child
                                    as={Fragment}
                                    enter="ease-out duration-300"
                                    enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                                    enterTo="opacity-100 translate-y-0 sm:scale-100"
                                    leave="ease-in duration-200"
                                    leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                                    leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95" >
                                    <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-zinc-900 px-4 pb-4 pt-5 text-left shadow-xl transition-all sm:my-8 w-11/12 sm:p-10" >
                                        <div className="absolute right-4 -top-4 hidden  h-fit pr-4 pt-4 sm:block w-10">
                                            <button
                                                type="button"
                                                className="rounded-md   focus:outline-none  "
                                                onClick={() => setOpenLayout(false)}
                                            >
                                                <span className="sr-only">Close</span>
                                                <img src={'/media/icon/noun-close-fff.svg'} className=' opacity-50 hover:opacity-80 absolute hover:scale-105 ' />
                                            </button>
                                        </div>
                                        <div>
                                            <div className='text-2xl text-gray-100'>

                                                Select Supercard Layout


                                                <div className="flex gap-4 mb-8 mt-8 text-base">

                                                    <div className='mt-2 mr-12 text-gray-300'>
                                                        Jump to Section
                                                    </div>

                                                    <button className="flex-auto bg-white/10 text-gray-50 p-3 rounded text-center hover:bg-white/20 cursor-pointer" onClick={() => scrollToElement("layout-icons")}>
                                                        Icons
                                                    </button>

                                                    <button className="flex-auto bg-white/10 text-gray-50 p-3 rounded text-center hover:bg-white/20 cursor-pointer" onClick={() => scrollToElement("layout-standard")}>
                                                        Standard
                                                    </button>

                                                    <button className="flex-auto bg-white/10 text-gray-50 p-3 rounded text-center hover:bg-white/20 cursor-pointer" onClick={() => scrollToElement("layout-text")}>
                                                        Text Only
                                                    </button>

                                                    <button className="flex-auto bg-white/10 text-gray-50 p-3 rounded text-center hover:bg-white/20 cursor-pointer" onClick={() => scrollToElement("layout-quotes")}>
                                                        Quotes
                                                    </button>

                                                    <button className="flex-auto bg-white/10 text-gray-50 p-3 rounded text-center hover:bg-white/20 cursor-pointer" onClick={() => scrollToElement("layout-interactive")}>
                                                        Interactive
                                                    </button>

                                                    {/* <div className="flex-auto bg-white/10 text-gray-50 p-3 rounded text-center">Industrial</div>
                            <div className="flex-auto bg-white/10 text-gray-50 p-3 rounded text-center">Diagram &amp; Arrows</div>
                            <div className="flex-auto bg-white/10 text-gray-50 p-3 rounded text-center">Mini Backgrounds</div> */}
                                                </div>


                                                <div className=" h-[60vh] overflow-y-auto pr-4 section-scroll">
                                                    <div id="layout-icons" className='mt-6 mb-4 font-semibold text-lg text-gray-300'>Icons</div>
                                                    <div className='grid grid-cols-6 gap-8'>
                                                        {layoutStyles.filter((item) => item.category == 'Icon').map((item, index) => (
                                                            <div key={item.name + 'iconkey'}>
                                                                <div className={` skyBackground1 h-48  rounded p-8  bg-gray-500/5  p-4 mx-auto  
                                                                
                                                                `}
                                                                    key={item.id + 'cardPreview'}>
                                                                    {/* <div
                                                                        style={{transform: 'scale(0.5)'}}
                                                                    > */}
                                                                    <ExpHTML
                                                                        thisIndex={-1}
                                                                        position={[0, 0, 0]}
                                                                        vizType={0}
                                                                        vizItem={{
                                                                            cardTitle: 'Title Is Here',
                                                                            name: 'Title Is Here',
                                                                            cardSubtitle: 'Subtitle of Card',
                                                                            cardBody: 'The body of your content will appear here and ',
                                                                            cardImage: 'data:image/svg+xml;base64,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',
                                                                            cardLayout: { id: item.id },
                                                                            animation: { name: 'none' },
                                                                            animationDuration: 0,
                                                                        }}
                                                                        key={index + 'SCViz'}
                                                                        storyData={storyData}
                                                                        htmlPreview={1}
                                                                    />
                                                                    {/* </div> */}
                                                                </div>

                                                                <div className='w-full mb-4 text-base'>
                                                                    <div className='w-full text-gray-200 pl-2 pt-2'>{item.name}</div>
                                                                    <div className='w-full text-gray-400 pl-2 pb-2'>{item.description || ''}</div>
                                                                    <button className="flex-auto bg-white/10 text-gray-50 p-3 rounded text-center w-full mt-4 hover:bg-white/20 cursor-pointer" onClick={() => {
                                                                        setCardLayout(item)
                                                                        setOpenLayout(false)
                                                                    }
                                                                    }>
                                                                        Select
                                                                        {/* {item.id} */}
                                                                    </button>
                                                                </div>

                                                            </div>
                                                        ))}
                                                    </div>

                                                    <div id="layout-standard" className='mt-6 mb-4 font-semibold text-lg text-gray-300'>Standard</div>
                                                    <div className='grid grid-cols-4 gap-12'>
                                                        {layoutStyles.filter((item) => item.category == 'Standard').map((item, index) => (
                                                            <div key={item.name}>
                                                                <div className={` skyBackground1 h-96 bg-gray-500/5 scale-100  rounded  p-4 mx-auto overflow-hidden `}
                                                                    key={item.id + 'cardPreview'}>
                                                                    <ExpHTML
                                                                        thisIndex={-1}
                                                                        position={[0, 0, 0]}
                                                                        vizType={0}
                                                                        vizItem={{
                                                                            cardTitle: 'Title Is Here',
                                                                            name: 'Title Is Here',
                                                                            cardSubtitle: 'Subtitle of Card',
                                                                            cardBody: 'The body of your content will appear here and ',
                                                                            cardImage: 'data:image/svg+xml;base64,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',
                                                                            cardLayout: { id: item.id },
                                                                            animation: { name: 'none' },
                                                                            animationDuration: 0,
                                                                        }}
                                                                        key={index + 'SCViz'}
                                                                        storyData={storyData}
                                                                        htmlPreview={1}
                                                                    //htmlPreviewScale={0.5}
                                                                    />
                                                                </div>

                                                                <div className='w-full mb-4 text-base'>
                                                                    <div className='w-full text-gray-200 pl-2 pt-2'>{item.name}</div>
                                                                    <div className='w-full text-gray-400 pl-2 pb-2'>{item.description || ''}</div>
                                                                    <button className="flex-auto bg-white/10 text-gray-50 p-3 rounded text-center w-full mt-4 hover:bg-white/20 cursor-pointer" onClick={() => {
                                                                        setCardLayout(item)
                                                                        setOpenLayout(false)
                                                                    }
                                                                    }>
                                                                        Select
                                                                        {/* {item.id} */}
                                                                    </button>
                                                                </div>

                                                            </div>
                                                        ))}
                                                    </div>

                                                    <div id="layout-text" className='mt-6 mb-4 font-semibold text-lg text-gray-300'>Text</div>
                                                    <div className='grid grid-cols-4 gap-8'>
                                                        {layoutStyles.filter((item) => item.category == 'Text').map((item, index) => (
                                                            <div key={item.name + '2'}>
                                                                <div className={` skyBackground1 h-64 bg-gray-500/5 scale-100  rounded p-4 mx-auto  `}
                                                                    key={item.id + 'cardPreview'}>
                                                                    <ExpHTML
                                                                        thisIndex={-1}
                                                                        position={[0, 0, 0]}
                                                                        vizType={0}
                                                                        vizItem={{
                                                                            cardTitle: 'Title Is Here',
                                                                            name: 'Title Is Here',
                                                                            cardSubtitle: 'Subtitle of Card',
                                                                            cardBody: 'The body of your content will appear here and ',
                                                                            cardImage: 'data:image/svg+xml;base64,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',
                                                                            cardLayout: { id: item.id },
                                                                            animation: { name: 'none' },
                                                                            animationDuration: 0,
                                                                        }}
                                                                        key={index + 'SCViz'}
                                                                        storyData={storyData}
                                                                        htmlPreview={1}
                                                                    //htmlPreviewScale={0.5}
                                                                    />
                                                                </div>

                                                                <div className='w-full mb-4 text-base'>
                                                                    <div className='w-full text-gray-200 pl-2 pt-2'>{item.name}</div>
                                                                    <div className='w-full text-gray-400 pl-2 pb-2'>{item.description || ''}</div>
                                                                    <button className="flex-auto bg-white/10 text-gray-50 p-3 rounded text-center w-full mt-4 hover:bg-white/20 cursor-pointer" onClick={() => {
                                                                        setCardLayout(item)
                                                                        setOpenLayout(false)
                                                                    }
                                                                    }>
                                                                        Select
                                                                        {/* {item.id} */}
                                                                    </button>
                                                                </div>

                                                            </div>
                                                        ))}
                                                    </div>

                                                    <div id="layout-quotes" className='mt-6 mb-4 font-semibold text-lg text-gray-300'>Quotes</div>
                                                    <div className='grid grid-cols-3 gap-8'>
                                                        {layoutStyles.filter((item) => item.category == 'Quote').map((item, index) => (
                                                            <div key={item.name + '3'}>
                                                                <div className={` skyBackground1 h-80 bg-gray-500/5 scale-100  rounded p-4 text-left `}
                                                                    key={item.id + 'cardPreview'}>
                                                                    <ExpHTML
                                                                        thisIndex={-1}
                                                                        position={[0, 0, 0]}
                                                                        vizType={0}
                                                                        vizItem={{
                                                                            cardTitle: 'Title Is Here',
                                                                            name: 'Title Is Here',
                                                                            cardSubtitle: 'Subtitle of Card',
                                                                            cardBody: 'The body of your content will appear here and ',
                                                                            cardImage: 'data:image/svg+xml;base64,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',
                                                                            cardLayout: { id: item.id },
                                                                            animation: { name: 'none' },
                                                                            animationDuration: 0,
                                                                        }}
                                                                        key={index + 'SCViz'}
                                                                        storyData={storyData}
                                                                        htmlPreview={1}
                                                                    //htmlPreviewScale={0.5}
                                                                    />
                                                                </div>

                                                                <div className='w-full mb-4 text-base'>
                                                                    <div className='w-full text-gray-200 pl-2 pt-2'>{item.name}</div>
                                                                    <div className='w-full text-gray-400 pl-2 pb-2'>{item.description || ''}</div>
                                                                    <button className="flex-auto bg-white/10 text-gray-50 p-3 rounded text-center w-full mt-4 hover:bg-white/20 cursor-pointer" onClick={() => {
                                                                        setCardLayout(item)
                                                                        setOpenLayout(false)
                                                                    }
                                                                    }>
                                                                        Select
                                                                        {/* {item.id} */}
                                                                    </button>
                                                                </div>

                                                            </div>
                                                        ))}
                                                    </div>




                                                    <div id="layout-interactive" className='mt-6 mb-4 font-semibold text-lg text-gray-300'>Interactive</div>
                                                    <div className='grid grid-cols-3 gap-8'>
                                                        {layoutStyles.filter((item) => item.category == 'Interactive').map((item, index) => (
                                                            <div key={item.name + '3'}>
                                                                <div className={` skyBackground1 h-80 bg-gray-500/5 scale-100  rounded p-4 text-left `}
                                                                    key={item.id + 'cardPreview'}>
                                                                    <ExpHTML
                                                                        thisIndex={-1}
                                                                        position={[0, 0, 0]}
                                                                        vizType={0}
                                                                        vizItem={{
                                                                            cardTitle: 'Title Is Here',
                                                                            name: 'Title Is Here',
                                                                            cardSubtitle: 'Subtitle of Card',
                                                                            cardBody: 'The body of your content will appear here and ',
                                                                            cardImage: 'data:image/svg+xml;base64,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',
                                                                            cardLayout: { id: item.id },
                                                                            animation: { name: 'none' },
                                                                            animationDuration: 0,
                                                                        }}
                                                                        key={index + 'SCViz'}
                                                                        storyData={storyData}
                                                                        htmlPreview={1}
                                                                    //htmlPreviewScale={0.5}
                                                                    />
                                                                </div>

                                                                <div className='w-full mb-4 text-base'>
                                                                    <div className='w-full text-gray-200 pl-2 pt-2'>{item.name}</div>
                                                                    <div className='w-full text-gray-400 pl-2 pb-2'>{item.description || ''}</div>
                                                                    <button className="flex-auto bg-white/10 text-gray-50 p-3 rounded text-center w-full mt-4 hover:bg-white/20 cursor-pointer" onClick={() => {
                                                                        setCardLayout(item)
                                                                        setOpenLayout(false)
                                                                    }
                                                                    }>
                                                                        Select
                                                                        {/* {item.id} */}
                                                                    </button>
                                                                </div>

                                                            </div>
                                                        ))}
                                                    </div>





                                                </div>



                                            </div>
                                        </div>
                                        {/* <div className="mt-5 sm:mt-6 sm:grid sm:grid-flow-row-dense sm:grid-cols-2 sm:gap-3">
                                            <button
                                                type="button"
                                                className="inline-flex w-full justify-center rounded-md bg-sky-600 px-3 py-2   text-white shadow-sm hover:bg-sky-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 sm:col-start-2
                                                "
                                                onClick={() => {
                                                    handleChange(iconSelected)
                                                    setOpenLayout(false)
                                                }
                                                }>
                                                Save
                                            </button>
                                            <button
                                                type="button"
                                                className="mt-3 inline-flex w-full justify-center 
                                                rounded bg-gray-500 px-3 py-2 bg-zinc-800
                                                text-base font-base text-gray-100 shadow-sm 
                                                hover:bg-zinc-700 sm:col-start-1 sm:mt-0"
                                                onClick={() => setOpenLayout(false)}
                                                ref={cancelButtonRef} >
                                                Cancel
                                            </button>
                                        </div> */}
                                    </Dialog.Panel>
                                </Transition.Child>
                            </div>
                        </div>
                    </Dialog>
                </Transition.Root>
            </>
        )
    }

    // End for layotus for SC





    const [cardTitle, setCardTitle] = useState(props.cardItem.cardTitle || '')
    const [cardSubtitle, setCardSubtitle] = useState(props.cardItem.cardSubtitle || '')
    const [cardBody, setCardBody] = useState(props.cardItem.cardBody || '')
    const [cardImage, setCardImage] = useState(props.cardItem.cardImage || '')
    const [cardAnimation, setCardAnimation] = useState(props.cardItem.animation || 'none')
    const [cardDelay, setCardDelay] = useState(props.cardItem.animationDuration || 1)
    const [cardLayout, setCardLayout] = useState(props.cardItem.cardLayout || { id: 1, name: 'none' })
    const [cardPositionXY, setCardPositionXY] = useState({ x: props.cardItem.pos.x, y: props.cardItem.pos.y } || { x: 0, y: 0 })
    const [cardScale, setCardScale] = useState(props.cardItem.scale || 1)
    const [cardFaceCamera, setCardFaceCamera] = useState(props.cardItem.faceCamera || false)
    //const [jumpSceneButton, setJumpSceneButton] = useState(props.cardItem.jumpSceneButton || { sceneId: 0, name: 'none', icon: 'blank' })
    //const [jumpSceneButton, setJumpSceneButton] = useState(props.cardItem.jumpSceneButton || [])

    // Used to dyanmically add scene buttons
    const [jumpSceneButton, setJumpSceneButton] = useState()
    const [sceneName, setSceneName] = useState('')

    const [jumpSceneButtons, setJumpSceneButtons] = useState(props.cardItem.jumpSceneButtons || [])

    // jumpButtonText
    const [jumpButtonText, setJumpButtonText] = useState('')

    let nextId = 0;


    function addNewSceneButton(jumpSceneButton) {
        console.log('Going to add new scene button to jump....')
        console.log(jumpSceneButton)
        const sceneButtonsCopy = Array.from(jumpSceneButtons)
        sceneButtonsCopy.push({
            id: jumpSceneButtons.length, sceneId: jumpSceneButton.sceneId, name: jumpButtonText
            //, icon: jumpSceneButton.icon 
        })
        setJumpSceneButtons(sceneButtonsCopy)
        setJumpButtonText('')
    }

    function deleteSceneButton(index) {
        const sceneButtonsCopy = Array.from(jumpSceneButtons)
        sceneButtonsCopy.splice(index, 1)
        setJumpSceneButtons(sceneButtonsCopy)
    }

    // useEffect(() => {
    //     handleSuperCardUpdate()
    // }, [jumpSceneButtons])

    // useEffect(() => {
    //     console.log('scene updated...!')
    //     // props.cardItem.guid
    //     // cardPositionXY
    //     // const [cardPositionXY, setCardPositionXY] = useState({ x: props.cardItem.pos.x, y: props.cardItem.pos.y } || { x: 0, y: 0 })
    //     setCardPositionXY({ x: props.cardItem.pos.x, y: props.cardItem.pos.y })

    // }, [sceneData]);

    // setArtists(
    //     artists.filter(a =>
    //       a.id !== artist.id
    //     )
    //   );

    // useEffect(() => {
    //     console.log('JUMP SCENE BUTTON')
    //     console.log(jumpSceneButton)
    // }, [jumpSceneButton])

    const faceCameraHandler = () => {
        setCardFaceCamera(!cardFaceCamera)
    }

    useEffect(() => {
        if (props.cardItem.cardImage) {
            setScImage(props.cardItem.cardImage)
        }
    }, [])

    useEffect(() => {
        let cloneVizActive = []
        cloneVizActive = [...props.sceneData[props.sessionData.activeIndex].viznodes]

        cloneVizActive.forEach(vizItem => {

            if (vizItem.guid == props.cardItem.guid) {
                vizItem['pos'] = cardPositionXY
            }
        })

        let cloneSceneDataActive = []
        cloneSceneDataActive = [...props.sceneData] //[props.sessionData.activeIndex].viznodes = cloneVizActive
        cloneSceneDataActive[props.sessionData.activeIndex].viznodes = cloneVizActive
        setSceneData(cloneSceneDataActive)

        const activeSceneId = sceneData[props.sessionData.activeIndex].id

        const sceneRef = doc(db, 'stories', props.storyId, 'scenes', activeSceneId);
        //await 
        updateDoc(sceneRef, {
            viznodes: cloneVizActive
        })

    }, [cardPositionXY]);


    const handleSuperCardPosUpdate = (newX, newY) => {

        let cloneVizActive = []
        cloneVizActive = [...props.sceneData[props.sessionData.activeIndex].viznodes]

        cloneVizActive.forEach(vizItem => {

            if (vizItem.guid == props.cardItem.guid) {
                vizItem['pos'] = { x: newX, y: newY } //cardPositionXY
            }
        })

        let activeSceneId = props.sceneData[props.sessionData.activeIndex].id
        const sceneRef = doc(db, 'stories', props.storyId, 'scenes', activeSceneId)

        updateDoc(sceneRef, {
            viznodes: cloneVizActive
        })
    }


    const handleSuperCardUpdate = () => {

        let cloneVizActive = []
        cloneVizActive = [...props.sceneData[props.sessionData.activeIndex].viznodes]

        cloneVizActive.forEach(vizItem => {

            if (vizItem.guid == props.cardItem.guid) {

                vizItem['cardTitle'] = cardTitle
                vizItem['cardSubtitle'] = cardSubtitle
                vizItem['cardBody'] = cardBody
                vizItem['cardImage'] = scImage //cardImage

                {
                    props.mode != 'icon' ?
                        vizItem['cardLayout'] = cardLayout
                        :
                        vizItem['cardLayout'] = { id: 2, name: 'Icon Only' }
                }

                vizItem['animation'] = cardAnimation
                //vizItem['blahblah'] = cardAnimation
                vizItem['animationDuration'] = cardDelay
                vizItem['pos'] = cardPositionXY
                vizItem['faceCamera'] = cardFaceCamera
                vizItem['scale'] = cardScale

                vizItem['jumpSceneButtons'] = jumpSceneButtons

            }
        })

        let activeSceneId = props.sceneData[props.sessionData.activeIndex].id
        const sceneRef = doc(db, 'stories', props.storyId, 'scenes', activeSceneId)

        updateDoc(sceneRef, {
            viznodes: cloneVizActive
        })
    }


    //handleSuperCardUpdate
    const handleBlur = (event) => {
        // Do something when the input field loses focus
        //handleSuperCardUpdate()
      }
    

    function classNames(...classes) {
        return classes.filter(Boolean).join(' ')
    }

    const updateImage = (title) => {
        //        console.log('GOT ICON SAVE IN PARENT....')
        setScImage(title)
    }

    useEffect(() => {
        // console.log('CARD IMAGE HAS UDPATED....')
        // console.log(cardImage)
    }, [cardImage]);

    return (
        <div className='pr-1'>
            <form onSubmit={(e) => {
                e.preventDefault()
            }}>
                <div className="sm:col-span-2 mt-4">


                    {props.mode != 'icon' ?
                        <div className="mt-4">
                            {/* <div className='flex w-full'>
                                <OpenLayoutSelectModal />
                            </div> */}
                            <div className="mt-2.5 grid-cols-2 gap-2 grid">
                                {/* <div className='flex w-1/5 text-gray-200 pt-2 pl-2 text-sm'>Layout</div> */}
                                <div className=' '>
                                    <OpenLayoutSelectModal />
                                </div>
                                <div className='text-sm text-left ml-2 mt-2'>
                                    {cardLayout.name}
                                </div>
                            </div>
                        </div>
                        : null}


                    <div className="mt-2.5 grid-cols-2 gap-2 grid">
                        <div>
                            <OpenIconSelectModal updateImage={updateImage} />
                        </div>
                        <div className=" text-left ml-2">
                            {scImage ?
                                <img src={scImage} className='h-8 mx-auto ' />
                                :
                                <div className='text-gray-50 text-sm  mt-2'>No Icon Selected</div>
                            }
                        </div>
                        {/* <OpenIconSelectModal setCardImage={setCardImage} /> */}
                    </div>




                    {/* TODO - dropdown with names of the scenes */}

                    {cardLayout.id == 22 || cardLayout.id == 23  || cardLayout.id == 24 ?
                        <>
                            <div className='w-full col-span-2 mt-4'>
                                {jumpSceneButtons.map((button) => (
                                    <div className='px-3 py-1 text-gray-100    rounded-md mb-2 text-sm w-full animate__animated anmiate_fadeIn flex justify-between'
                                        key={button.id + button.sceneId + '-' + button.name}
                                    >
                                        <div className='flex-auto'>
                                            {button.name}
                                        </div>
                                        <div className='w-12'>
                                            {button.sceneId + 1}
                                        </div>
                                        <div className=''>
                                            <div className="cursor-pointer" onClick={() => deleteSceneButton(button.id)}>
                                                <img src="/media/icon/noun-trash-5765342-FFFFFF.svg" className="h18 o5" />
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className='flex w-full'>
                                <div className='flex w-1/4 text-gray-200 pt-5 ml-1 text-sm pr-3'>
                                    Jump To
                                </div>
                                <div className='flex-none w-3/4'>

                                    <div className='grid grid-cols-5 gap-3 mt-3  '>
                                        <div className='col-span-5'>
                                            <Listbox
                                                //value={jumpSceneButton.name } 
                                                onChange={setJumpSceneButton}>
                                                {({ open }) => (
                                                    <>
                                                        <div className="relative  ">
                                                            <Listbox.Button className="relative w-full cursor-default rounded-md bg-white/5 py-2 pl-3 pr-10 text-left text-gray-200 shadow-sm ring-1 ring-inset ring-gray-900 focus:outline-none   sm:text-sm sm:leading-6 hover:bg-white/10 ">
                                                                <span className="block truncate">
                                                                    {/* {jumpSceneButton.name || 'select scene'} &nbsp; */}
                                                                    select scene &nbsp;
                                                                </span>
                                                                <span className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2">
                                                                    <ChevronUpDownIcon className="h-5 w-5 text-gray-400" aria-hidden="true" />
                                                                </span>
                                                            </Listbox.Button>

                                                            <Transition
                                                                show={open}
                                                                as={Fragment}
                                                                leave="transition ease-in duration-100"
                                                                leaveFrom="opacity-100"
                                                                leaveTo="opacity-0"
                                                            >
                                                                <Listbox.Options className="absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-zinc-800 py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm">
                                                                    {
                                                                        //sceneData.filter(item => item.navOmitMain != true).map((scene) => (
                                                                        sceneData.map((scene) => (
                                                                            <Listbox.Option
                                                                                key={'sceneid_' + scene.order}
                                                                                className={({ active }) =>
                                                                                    classNames(
                                                                                        active ? 'bg-sky-500 text-white' : 'text-gray-300',
                                                                                        'relative cursor-default select-none py-2 pl-3 pr-9'
                                                                                    )
                                                                                }
                                                                                value={{ sceneId: scene.order, name: scene.name }}
                                                                            >
                                                                                {({ jumpSceneButton, active }) => (
                                                                                    <>
                                                                                        <span className={classNames(jumpSceneButton ? 'font-semibold' : 'font-normal', 'block truncate')}>
                                                                                            {scene.name}
                                                                                        </span>

                                                                                        {jumpSceneButton ? (
                                                                                            <span
                                                                                                className={classNames(
                                                                                                    active ? 'text-white' : 'text-sky-600',
                                                                                                    'absolute inset-y-0 right-0 flex items-center pr-4'
                                                                                                )}
                                                                                            >
                                                                                                <CheckIcon className="h-5 w-5" aria-hidden="true" />
                                                                                            </span>
                                                                                        ) : null}
                                                                                    </>
                                                                                )}
                                                                            </Listbox.Option>
                                                                        ))}
                                                                </Listbox.Options>
                                                            </Transition>
                                                        </div>
                                                    </>
                                                )}
                                            </Listbox>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='w-full mt-2.5 flex mb-4'>
                                <div className="flex-auto">
                                    <input
                                        autoComplete="off"
                                        value={jumpButtonText}
                                        onChange={(e) => setJumpButtonText(e.target.value)}
                                        type="text"
                                        // name="persona-name"
                                        // id="persona-name"
                                        placeholder='Text for Button'
                                        className="block w-full rounded-md border-0 bg-white/5 px-3.5 py-2 
                      text-white shadow-sm ring-1 ring-inset ring-white/10 focus:ring-2 
                      focus:ring-inset focus:ring-sky-500 sm:text-sm sm:leading-6"
                                    />
                                </div>
                                <div
                                    className='ml-4 cursor-pointer w-10 justify-center rounded-md bg-sky-500 px-3 py-1
                            text-lg text-white  bg-sky-500 hover:bg-sky-400 text-center'
                                    onClick={() => {
                                        addNewSceneButton(jumpSceneButton)
                                    }}>
                                    +
                                </div>
                            </div>


                        </>
                        : null}


                    {props.mode != 'icon' ?
                        <>
                            <div className="mt-2.5">
                                <input
                                    autoComplete="off"
                                    value={cardTitle}
                                    onChange={(e) => setCardTitle(e.target.value)}
                                    type="text"
                                    // name="persona-name"
                                    // id="persona-name"
                                    placeholder='Title'
                                    onBlur={handleBlur} 
                                    className="block w-full rounded-md border-0 bg-white/5 px-3.5 py-2 
                      text-white shadow-sm ring-1 ring-inset ring-white/10 focus:ring-2 
                      focus:ring-inset focus:ring-sky-500 sm:text-sm sm:leading-6"
                                />
                            </div>
                            <div className="mt-2.5">
                                <input
                                    autoComplete="off"
                                    value={cardSubtitle}
                                    onChange={(e) => setCardSubtitle(e.target.value)}
                                    type="text"
                                    placeholder='Subtitle'
                                    onBlur={handleBlur} 
                                    // name="persona-role"
                                    // id="phone-number"
                                    className="block w-full rounded-md border-0 bg-white/5 px-3.5 py-2 
                      text-white shadow-sm ring-1 ring-inset ring-white/10 focus:ring-2 
                      focus:ring-inset focus:ring-sky-500 sm:text-sm sm:leading-6"
                                />
                            </div>







                            <div className="mt-2.5">
                                <textarea
                                    autoComplete="off"
                                    value={cardBody}
                                    onChange={(e) => setCardBody(e.target.value)}
                                    type="text"
                                    rows={5}
                                    onBlur={handleBlur} 
                                    placeholder='Body of card'
                                    // name="persona-detail"
                                    // id="persona-detail"
                                    className="block w-full rounded-md border-0 bg-white/5 px-3.5 py-2 
                      text-white shadow-sm ring-1 ring-inset ring-white/10 focus:ring-2 
                      focus:ring-inset focus:ring-sky-500 sm:text-sm sm:leading-6"
                                />
                            </div>

                            <div className="mt-2.5 grid grid-cols-2 gap-0">

                                <div className="relative flex items-start">
                                    <div className="ml-1 text-sm leading-6 mr-2">
                                        {/* <label htmlFor="candidates" className="font-medium text-gray-100">
                                            Turn to face camera
                                        </label> */}
                                        <p id="candidates-description" className="text-gray-300 text-sm mt-2">
                                            Always Face
                                        </p>
                                    </div>
                                    <div className="flex h-6 items-center mt-2">
                                        <input
                                            id="faceCamera"
                                            aria-describedby="faceCamera"
                                            name="faceCamera"
                                            type="checkbox"
                                            checked={cardFaceCamera}
                                            onChange={faceCameraHandler}
                                            className="h-4 w-4 rounded border-gray-300 text-sky-600 focus:ring-sky-600"
                                        />
                                    </div>
                                </div>


                                <div className='grid grid-cols-5 gap-0'>
                                    <div id="" className="text-gray-300 col-span-2 text-sm mt-2 text-right mr-2">
                                        Scale
                                    </div>

                                    <div className='grid grid-cols-10 gap-0 col-span-3 ml-2'>
                                        <div className='col-span-3  p-2  text-center  text-center font-bold cursor-pointer bg-white/5 hover:bg-white/10 rounded'
                                            onClick={(e) =>
                                                //setCardScale(cardScale - .25)
                                                cardScale > 0 ? setCardScale(cardScale - .25) : 0
                                            }
                                        >-</div>
                                        <div className='col-span-4'>
                                            <div className='className="block w-full rounded-md border-0  px-1.5 py-2 
                      text-white   sm:text-sm sm:leading-6 text-center'>
                                                {cardScale}
                                            </div>
                                        </div>
                                        <div className='col-span-3 p-2  text-center font-bold cursor-pointer bg-white/5 hover:bg-white/10 rounded'
                                            onClick={(e) => setCardScale(cardScale + .25)}
                                        >+</div>
                                    </div>
                                </div>
                            </div>

                        </>
                        :
                        //                         <div className="mt-2.5">
                        // <div className='text-gray-300 text-sm'>Quick Icon </div>
                        // <div className='text-gray-300 text-sm'>Select an icon and it will be added to the card *** use some longer via Figma!!</div>
                        // <div className='text-gray-300 text-sm' onClick={() => updateImage('/media/icon/noun-devices-51939-FFFFFF.svg')}>click</div>
                        //                             </div>
                        null
                    }


                    <div className='flex w-full'>

                        <div className='flex w-1/4 text-gray-200 pt-5 ml-1 text-sm pr-3'>
                            Animation
                        </div>
                        <div className='flex-auto'>

                            <div className='grid grid-cols-5 gap-3 mt-3  '>
                                <div className='col-span-3'>
                                    <Listbox value={cardAnimation} onChange={setCardAnimation}>
                                        {({ open }) => (
                                            <>
                                                {/* <Listbox.Label className="block leading-6 text-gray-300">Animation</Listbox.Label> */}
                                                <div className="relative  ">
                                                    <Listbox.Button className="relative w-full cursor-default rounded-md bg-white/5 py-2 pl-3 pr-10 text-left text-gray-200 shadow-sm ring-1 ring-inset ring-gray-900 focus:outline-none   sm:text-sm sm:leading-6
                                                    hover:bg-white/10
                                                    ">
                                                        <span className="block truncate">{cardAnimation.displayName || 'none'} &nbsp;</span>
                                                        <span className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2">
                                                            <ChevronUpDownIcon className="h-5 w-5 text-gray-400" aria-hidden="true" />
                                                        </span>
                                                    </Listbox.Button>

                                                    <Transition
                                                        show={open}
                                                        as={Fragment}
                                                        leave="transition ease-in duration-100"
                                                        leaveFrom="opacity-100"
                                                        leaveTo="opacity-0"
                                                    >
                                                        <Listbox.Options className="absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-zinc-800 py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm">
                                                            {animationStyles.map((person) => (
                                                                <Listbox.Option
                                                                    key={person.id}
                                                                    className={({ active }) =>
                                                                        classNames(
                                                                            active ? 'bg-sky-500 text-white' : 'text-gray-300',
                                                                            'relative cursor-default select-none py-2 pl-3 pr-9'
                                                                        )
                                                                    }
                                                                    value={person}
                                                                >
                                                                    {({ cardAnimation, active }) => (
                                                                        <>
                                                                            <span className={classNames(cardAnimation ? 'font-semibold' : 'font-normal', 'block truncate')}>
                                                                                {person.displayName}
                                                                            </span>

                                                                            {cardAnimation ? (
                                                                                <span
                                                                                    className={classNames(
                                                                                        active ? 'text-white' : 'text-sky-600',
                                                                                        'absolute inset-y-0 right-0 flex items-center pr-4'
                                                                                    )}
                                                                                >
                                                                                    <CheckIcon className="h-5 w-5" aria-hidden="true" />
                                                                                </span>
                                                                            ) : null}
                                                                        </>
                                                                    )}
                                                                </Listbox.Option>
                                                            ))}
                                                        </Listbox.Options>
                                                    </Transition>
                                                </div>
                                            </>
                                        )}
                                    </Listbox>
                                </div>

                                <div className='col-span-2'>

                                    <div className='grid grid-cols-10 gap-0'>
                                        <div className='col-span-3  p-2  text-center  text-center font-bold cursor-pointer bg-white/5 hover:bg-white/10 rounded'
                                            onClick={(e) =>
                                                //setCardDelay(cardDelay - 1)
                                                cardDelay > 0 ? setCardDelay(cardDelay - 1) : 0
                                            }
                                        >-</div>
                                        <div className='col-span-4'>
                                            <div className='className="block w-full rounded-md border-0  px-1.5 py-2 
                      text-white   sm:text-sm sm:leading-6 text-center'>
                                                {!cardAnimation.displayName ? 0 : cardDelay}
                                            </div>
                                        </div>
                                        <div className='col-span-3 p-2  text-center font-bold cursor-pointer bg-white/5 hover:bg-white/10 rounded'
                                            onClick={(e) => setCardDelay(cardDelay + 1)}
                                        >+</div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>


                    {/* <div className='text-gray-400 h-4 float-right text-sm mt-2' style={{ height: '20px' }}>
                        

                        {cardPositionXY.x}, {cardPositionXY.y}


                    </div> */}







                    {/* <div className="flex w-full  float-left  mr-2 ml-2 text-gray-300 mb-2">
                        <div className='flex mt-2.5 w-full pr-2 gap-x-1'>
                            <div className='flex w-1/4 mt-2 text-sm'>
                                Position
                            </div>
                            <div
                                className={`flex w-1/3 -ml-1`} >

                                <input
                                    className=" bg-black/50 px-3  text-center block   w-14   rounded-md border-0  py-2.5 bg-transparent text-gray-100 shadow-sm ring-1 ring-inset
        ring-zinc-800 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-sky-400 text-sm sm:leading-6v focus:outline-none"
                                    type="number" pattern='^[0-9]*$'
                                    value={
                                        //cardPositionXY.x || 0
                                        props.cardItem.pos.x
                                    }
                                    onChange={(e) =>
                                        setCardPositionXY({ x: e.target.value, y: cardPositionXY.y })
                                    }
                                />
                                <img src="/util/app/b3-admin-arrow-horiz.svg " className="w-8 h-8 p-1 opacity-50" />
                            </div>
                            <div
                                className={`flex w-1/3 ml-4`} >

                                <input
                                    className="remove-arrow bg-black/50 px-3  text-center block   w-14   rounded-md border-0  py-2.5 bg-transparent text-gray-100 shadow-sm ring-1 ring-inset
        ring-zinc-800 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-sky-400 text-sm sm:leading-6v focus:outline-none"
                                    type="number" pattern='^[0-9]*$'
                                    //onChange={setPersonaPositionXY}
                                    value={
                                        //cardPositionXY.y || 0
                                        props.cardItem.pos.y
                                    }
                                    onChange={(e) =>
                                        setCardPositionXY({ x: cardPositionXY.x, y: e.target.value })
                                        //setPersonaDelay(e.target.value)
                                    }
                                />
                                <img src="/util/app/b3-admin-arrow-vert.svg " className="w-8 h-8 p-1 opacity-50" />
                            </div>
                        </div>
                    </div> */}




                    <div className='w-100p   slider-parent mt-3'>

                        <GridSelect
                            //viznodes
                            viznodes={props.sceneData[props.sessionData.activeIndex].viznodes}
                            activeNode={props.cardItem.guid}
                            setCardPositionXY={setCardPositionXY}
                        />


                        {/* <Slider
                            axis="xy"
                            xmin={cardFaceCamera ? -80 : -30}
                            xmax={cardFaceCamera ? 80 : 30}
                            ymin={cardFaceCamera ? -60 : -10}
                            ymax={cardFaceCamera ? 60 : 30}
                            xreverse={true}
                            yreverse={true}
                            x={cardPositionXY.x}
                            y={cardPositionXY.y}
                            onDragEnd={
                                (e) => {
                                }
                            }
                            onChange={
                                setCardPositionXY
                            }
                            styles={{
                                active: {
                                    backgroundColor: '#333'
                                },
                                track: {
                                    backgroundColor: '#1b1e21'
                                }
                            }}
                        /> */}
                    </div>



                    <div className="mt-4  ">
                        <button onClick={() => handleSuperCardUpdate()}
                            className='w-full justify-center rounded-md bg-sky-500 px-3 py-1
                      text-l font-base text-white shadow-sm bg-sky-500 hover:bg-sky-400  '
                        >Update</button>
                    </div>
                </div>
            </form>
        </div>
    )
}



// return (
//     <div className='text-gray-100'>
//         {/* Layout Style<br />
//         Show Highlight Bool<br />
//         Image<br />
//         List Items - Icon + Text...<br /> */}
//         <FormSupercard cardItem={props.cardItem} sceneData={props.sceneData} />
//     </div>
// );

//};

export default ConfigSuperCard;